module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('ul', {
    staticClass: "breadcrumb",
    class: {
      arrow: _vm.arrow
    }
  }, [_vm._t("default"), _vm._v(" "), _vm._l((_vm.data), function(nav, index) {
    return (!!_vm.data) ? _c('li', {
      class: [{
        active: nav.active
      }],
      on: {
        "click": function($event) {
          _vm.changeNav(nav.name)
        }
      }
    }, [(!nav.active) ? _c('a', [_vm._v(_vm._s(nav.name))]) : _c('span', [_vm._v(_vm._s(nav.name))]), _vm._v(" ")]) : _vm._e()
  })], true)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-dbb58b00!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/breadcrumbs.vue
// module id = 337
// module chunks = 2